import { render, staticRenderFns } from "./HomePageMainItem.vue?vue&type=template&id=65c80ca0&scoped=true&"
import script from "./HomePageMainItem.vue?vue&type=script&lang=js&"
export * from "./HomePageMainItem.vue?vue&type=script&lang=js&"
import style0 from "./HomePageMainItem.vue?vue&type=style&index=0&id=65c80ca0&lang=scss&scoped=true&"
import style1 from "./HomePageMainItem.vue?vue&type=style&index=1&id=65c80ca0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65c80ca0",
  null
  
)

export default component.exports